/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema } from '../../apiResponse';

const bulkDraftResultStatusSchema = z.enum([
  'created',
  'exists_slug',
  'exists_normalized',
  'exists_collapsed',
  'exists_variant',
  'exists_wildcard',
  'failed',
]);

const bulkDraftResultSchema = z.object({
  title: z.string(),
  status: bulkDraftResultStatusSchema,
  challengeId: z.number().optional(),
  challengeTitle: z.string().optional(),
  error: z.string().optional(),
});

export type IBulkDraftResult = z.infer<typeof bulkDraftResultSchema>;

export const bulkDraftChallengesResponseSchema = createApiResponseSchema(
  z.array(bulkDraftResultSchema),
);

export type IBulkDraftChallengesResponse = z.infer<typeof bulkDraftChallengesResponseSchema>;
